<template>
	<el-container class="wrap-80">
		<div class="guide-content">
			<div class="info-head tc">
				<h3 class="info-title">操作指引</h3>
			</div>
			<div class="guide-body">
				<div v-for="(section, sIdx) in guideList" :key="sIdx" class="guide-section">
					<h3 class="guide-section-title">{{ section.title }}</h3>
					<div v-for="(info, iIdx) in section.infos" :key="iIdx" class="guide-item">
						<div class="guide-item-content">
							<p class="guide-item-desc">{{ info.desc }}</p>
						</div>
						<div v-if="info.source" class="guide-item-video">
							<VideoPlayer :source="info.source" @playing="onVideoPlay" @paused="onVideoPause" @ended="onVideoEnded" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-container>
</template>

<script>
	import VideoPlayer from '@/components/VideoPlayer/index.vue';
	export default {
		name: 'Guide',
		components: { VideoPlayer },
		data() {
			return {
				activePlayer: null, // 当前正在播放的视频组件实例
				guideList: [
					{
						title: '平台登录',

						infos: [
							{
								desc: '点右上角登录按钮（首次登录需使用手机号与验证码登录，如尚未绑定企业，请先申请企业账号，企业账号申请请联系：18911620150）',
								source: 'https://img2.teguitong.com/ld/20260618-134602.mp4'  /// 登录
							}
						]
					},
					{
						title: '法规标准查询（特种设备库/全国库）',
						infos: [
							{
								desc: '1、法规标准知识体系：包含11种文件类型，10种设备分类，文件状态分类等',
								source: 'https://img2.teguitong.com/ld/20260618-134609.mp4'  /// 法规标准知识体系
							},
							{
								desc: '2、标准详情页：基本信息、内容介绍、目录预览、文件历史、引用文件等',
								source: 'https://img2.teguitong.com/ld/20260618-134615.mp4',  /// 标准详情页
							},
							{
								desc: '3、PDF文件与智能文档：PDF原文阅读，智能文档可复制且添加笔记',
								source: 'https://img2.teguitong.com/ld/20260618-134621.mp4'  /// 智能文档
							}
						]
					},
					{
						title: 'AI-行业大模型（快速回答/深度思考/书单模式）',
						infos: [
							{
								desc: '1、回答结果与法规、规章、安全技术规范、标准原文依据的关联、引用和可追溯性',
								source: 'https://img2.teguitong.com/ld/20260618-134627.mp4'  /// 智能文档
							},
							{
								desc: '2、系统检索效率、结果呈现、原文核验',
								source: 'https://img2.teguitong.com/ld/20260618-134550.mp4'  /// 检索效率
							}
						]
					},
					{
						title: '平台还提供更多功能可使用',
						infos: [
							{
								desc: '例如，企业资料馆——统一归档内部资料，搭载 AI 检索问答；支持书单归类资料并接入 AI 对话，另有现成推荐书单供企业直接选用。',
								source: ''
							}
						]
					}
				]
			};
		},
		methods: {
			// 视频开始播放 → 停止之前播放的视频
			onVideoPlay(playerInstance) {
				if (this.activePlayer && this.activePlayer !== playerInstance) {
					this.activePlayer.pause();
				}
				this.activePlayer = playerInstance;
			},
			// 视频暂停 → 清除记录
			onVideoPause(playerInstance) {
				if (this.activePlayer === playerInstance) {
					this.activePlayer = null;
				}
			},
			// 视频播放结束 → 清除记录
			onVideoEnded(playerInstance) {
				if (this.activePlayer === playerInstance) {
					this.activePlayer = null;
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.wrap-80 {
		width: 78%;
		max-width: 1200px;
		margin: 0 auto;
		padding: 20px 0;
		display: flex !important;
		justify-content: space-between;
	}

	.guide-content {
		flex: 1;
		// margin-left: 20px;
		background: #fff;
		border-radius: 12px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		line-height: 1.8;
		.info-head {
			margin-bottom: 25px;
			padding-bottom: 15px;
			border-bottom: 1px dashed #e2e8f0;
			padding-top: 20px;
		}
		.info-title {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}

	.guide-body {
		font-size: 15px;
		color: #475569;
		line-height: 1.8;
		padding: 0 30px 40px;

		p {
			margin: 0;
		}
	}

	/* ===== 指南分区 ===== */
	.guide-section {
		margin-bottom: 36px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.guide-section-title {
		font-size: 18px;
		font-weight: 700;
		color: #1f2329;
		margin: 0 0 6px 0;
		padding-left: 12px;
		border-left: 3px solid #2563eb;
		line-height: 1.4;
	}

	/* ===== 指南条目行 ===== */
	.guide-item {
		// display: flex;
		// align-items: flex-start;
		// gap: 16px;
		padding: 14px 16px;
		// background: #fafbfc;

		margin-bottom: 10px;
		transition: box-shadow 0.2s, border-color 0.2s;

		&:last-child {
			margin-bottom: 0;
		}

		&:hover {
			// border-color: #e2e8f0;
			// box-shadow: 0 2px 8px rgb(222,224,227);
		}
	}

	/* ===== 序号圆圈 ===== */
	.guide-item-index {
		flex-shrink: 0;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: linear-gradient(135deg, #2563eb, #5b8def);
		color: #fff;
		font-size: 13px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 2px;
	}

	/* ===== 描述文字 ===== */
	.guide-item-content {
		flex: 1;
		min-width: 0;
	}

	.guide-item-desc {
		font-size: 16px;
		color: #1f2329;
		line-height: 1.75;
	}

	/* ===== 视频占位卡 ===== */
	.guide-item-video {
		width: 100%;
		max-width: 1120px;
		aspect-ratio: 16 / 9;
		margin-top: 30px;
		border: 1px solid rgb(222, 224, 227);
		border-radius: 8px;
        overflow: hidden;
	}

	.video-placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 6px;
		height: 90px;
		background: #f8fafc;
		border: 1px dashed #cbd5e1;
		border-radius: 8px;
		cursor: pointer;
		transition: background 0.2s, border-color 0.2s;

		&:hover {
			background: #eff6ff;
			border-color: #2563eb;

			.video-placeholder-icon {
				background: #2563eb;
			}

			.video-placeholder-text {
				color: #2563eb;
			}
		}
	}

	.video-placeholder-icon {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: #94a3b8;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background 0.2s;
	}

	.video-placeholder-text {
		font-size: 12px;
		color: #94a3b8;
		font-weight: 500;
		transition: color 0.2s;
	}

	// 媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.wrap-80 {
			width: 96%;
		}

		.guide-body {
			padding: 0 20px 40px;
		}
	}

	@media screen and (max-width: 767px) {
		.guide-body {
			padding: 0 16px 32px;
		}

		.guide-item {
			flex-wrap: wrap;
		}

		.guide-item-video {
			width: 100%;
		}

		.video-placeholder {
			flex-direction: row;
			height: 52px;
			gap: 10px;
		}

		.video-placeholder-icon {
			width: 32px;
			height: 32px;
		}
	}
</style>
